var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92969 4.25H4.125C4.52344 4.25 4.875 4.60156 4.875 5C4.875 5.42188 4.52344 5.75 4.125 5.75H1.125C0.703125 5.75 0.375 5.42188 0.375 5V2C0.375 1.60156 0.703125 1.25 1.125 1.25C1.52344 1.25 1.875 1.60156 1.875 2V3.21875L2.27344 2.79688C4.33594 0.757812 7.64062 0.757812 9.70312 2.79688C11.7422 4.85938 11.7422 8.16406 9.70312 10.2266C7.64062 12.2656 4.33594 12.2656 2.27344 10.2266C1.99219 9.92188 1.99219 9.45312 2.27344 9.17188C2.57812 8.86719 3.04688 8.86719 3.32812 9.17188C4.80469 10.625 7.17188 10.625 8.64844 9.17188C10.1016 7.69531 10.1016 5.32812 8.64844 3.85156C7.17188 2.39844 4.80469 2.39844 3.32812 3.85156L2.92969 4.25Z",
    fill: "#111113"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/IconRefresh.e8b3526fc6b99675b9802bb3f864980e.svg";
export { ForwardRef as ReactComponent };